module.exports = __webpack_public_path__ + "img/test.9e2a7c9c.jpg";